import {
  createPlugins,
  isBlockAboveEmpty,
  isSelectionAtBlockStart,
} from "@udecode/plate-core";
import {
  createBoldPlugin,
  createItalicPlugin,
  createUnderlinePlugin,
} from "@udecode/plate-basic-marks";
import { createBlockquotePlugin } from "@udecode/plate-block-quote";
import { createListPlugin } from "@udecode/plate-list";
import { createParagraphPlugin } from "@udecode/plate-paragraph";
import { createSoftBreakPlugin } from "@udecode/plate-break";
import { createTrailingBlockPlugin } from "@udecode/plate-trailing-block";
import { createResetNodePlugin } from "@udecode/plate-reset-node";

import { TextEditorLeaf } from "./TextEditorLeaf";
import { TextEditorElement } from "./TextEditorElement";
import {
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_BLOCKQUOTE,
  ELEMENT_LI,
  MARK_BOLD,
  MARK_ITALIC,
  MARK_UNDERLINE,
  ELEMENT_PARAGRAPH,
} from "./constants";

import type { Editor, EditorValue } from "./types";

const softBreakPlugin = {
  options: {
    rules: [
      { hotkey: "shift+enter" },
      {
        hotkey: "enter",
        query: {
          allow: [ELEMENT_BLOCKQUOTE],
        },
      },
    ],
  },
};

const trailingBlockPlugin = {
  options: { type: ELEMENT_PARAGRAPH },
};

const resetBlockTypesCommonRule = {
  types: [ELEMENT_BLOCKQUOTE],
  defaultType: ELEMENT_PARAGRAPH,
};

export const resetBlockTypePlugin = {
  options: {
    rules: [
      {
        ...resetBlockTypesCommonRule,
        hotkey: "enter",
        predicate: isBlockAboveEmpty,
      },
      {
        ...resetBlockTypesCommonRule,
        hotkey: "backspace",
        predicate: isSelectionAtBlockStart,
      },
    ],
  },
};

export const plugins = createPlugins<EditorValue, Editor>(
  [
    createTrailingBlockPlugin(trailingBlockPlugin),
    createResetNodePlugin(resetBlockTypePlugin),
    createSoftBreakPlugin(softBreakPlugin),
    createBoldPlugin(),
    createItalicPlugin(),
    createUnderlinePlugin(),
    createBlockquotePlugin(),
    createParagraphPlugin(),
    createListPlugin(),
  ],
  {
    components: {
      [MARK_BOLD]: TextEditorLeaf,
      [MARK_ITALIC]: TextEditorLeaf,
      [MARK_UNDERLINE]: TextEditorLeaf,
      [ELEMENT_BLOCKQUOTE]: TextEditorElement,
      [ELEMENT_PARAGRAPH]: TextEditorElement,
      [ELEMENT_UL]: TextEditorElement,
      [ELEMENT_OL]: TextEditorElement,
      [ELEMENT_LI]: TextEditorElement,
    },
  },
);
